import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/employee.js";
import "@ui5/webcomponents-icons/dist/time-entry-request.js";
import "@ui5/webcomponents-icons/dist/calendar.js";
import "@ui5/webcomponents-icons/dist/wallet.js";
import "@ui5/webcomponents-icons/dist/lead.js";
import "@ui5/webcomponents-icons/dist/request.js";
import "@ui5/webcomponents-icons/dist/person-placeholder.js";
import "@ui5/webcomponents-icons/dist/action-settings.js";
import "@ui5/webcomponents-icons/dist/appointment-2.js";
import "@ui5/webcomponents-icons/dist/money-bills.js";

import { hrPermissions } from "./permissions";

/** HR & Payroll entries of the navigation registry (group `hr`, plan module `hr`). */
export const hrNavigation: readonly NavigationEntry[] = [
  {
    key: "hr.employees",
    labelKey: "nav.hrEmployees",
    icon: "employee",
    path: "/hr/employees",
    permission: hrPermissions.employeeView,
  },
  {
    key: "hr.attendance",
    labelKey: "nav.hrAttendance",
    icon: "time-entry-request",
    path: "/hr/attendance",
    permission: hrPermissions.attendanceDayView,
  },
  {
    key: "hr.leave",
    labelKey: "nav.hrLeave",
    icon: "calendar",
    path: "/hr/leave",
    permission: hrPermissions.leaveRequestView,
  },
  {
    key: "hr.payroll",
    labelKey: "nav.hrPayroll",
    icon: "wallet",
    path: "/hr/payroll",
    permission: hrPermissions.payrollRunView,
  },
  {
    key: "hr.workSchedules",
    labelKey: "nav.hrWorkSchedules",
    icon: "appointment-2",
    path: "/hr/work-schedules",
    permission: hrPermissions.workScheduleView,
    subGroup: "periodEnd",
  },
  { key: "hr.loans", labelKey: "nav.hrLoans", icon: "lead", path: "/hr/loans", permission: hrPermissions.loanView },
  {
    key: "hr.provisions",
    labelKey: "nav.hrProvisions",
    icon: "money-bills",
    path: "/hr/provisions",
    permission: hrPermissions.eosProvisionView,
    subGroup: "periodEnd",
  },
  {
    key: "hr.requests",
    labelKey: "nav.hrRequests",
    icon: "request",
    path: "/hr/requests",
    permission: hrPermissions.hrRequestView,
  },
  {
    key: "hr.self",
    labelKey: "nav.hrSelfService",
    icon: "person-placeholder",
    path: "/hr/self",
    permission: hrPermissions.selfServiceUse,
  },
  {
    key: "hr.settings",
    labelKey: "nav.hrSettings",
    icon: "action-settings",
    path: "/hr/settings",
    permission: hrPermissions.settingsView,
    subGroup: "periodEnd",
  },
];
